import React from 'react';

const Vue_Form_Inputs = () => {
  return (
    <div>
      <h1>Vue_Form_Inputs Component</h1>
      <p>This is the Vue_Form_Inputs tutorial page.</p>
    </div>
  );
}

export default Vue_Form_Inputs;
